export default "__VITE_ASSET__tVnlJuNO__"